<div class="stats-dialog">
  <div class="scroll-container">
    <div class="header"
      [ngClass]="{'fh': settingsManager.settings.theme == 'fh', 'modern': settingsManager.settings.theme == 'modern'}">
      <div class="title">
        <div class="image">
          <div class="outer-border">
            <div class="inner-border">
              <div class="image-container">
                @if (!monster.noThumbnail && settingsManager.settings.artwork) {
                <img [src]="gameManager.monsterManager.monsterThumbnail(monster)">
                }
                @if (monster.noThumbnail || !settingsManager.settings.artwork) {
                <span class="letter">
                  @for (namePart of (settingsManager.getLabel('data.monster.' + monster.name).split(' ')); track
                  namePart) {
                  <span>{{namePart[0]}}</span>
                  }
                </span>
                }
              </div>
            </div>
          </div>
          @if (monster.boss || monster.tags.indexOf('boss') != -1) {
          <span class="boss"><img src="./assets/images/monster/enemy.png" /></span>
          }
          @if (monster.standeeShare || monster.statEffect || statEffectNote) {
          <span class="custom">*</span>
          }
        </div>
        <div class="name"><span [ghs-label]="'data.monster.' + monster.name"></span></div>
      </div>
      @if (statEffectNote) {
      <p class="stat-effect text-white" [ghs-label]="statEffectNote"></p>
      }
    </div>
    <div class="container">
      @if (!hideStats) {
      <div class="stats">
        <ghs-monster-stats [monster]="monster" [forceStats]="true"> </ghs-monster-stats>
      </div>
      }
    </div>
    <div class="container">
      @for (ability of abilities | trackUUID; track ability._trackUUID; let index = $index) {
      <div class="ability" [ngClass]="{'bottom-actions' : gameManager.hasBottomAbility(ability)}" ghs-pointer-input
        (singleClick)="close()" (doubleClick)="openAbility(ability)">
        <ghs-ability [ability]="ability" [monster]="monster" [flipped]="true" [reveal]="true" [relative]="true"
          [statsCalculation]="false">
        </ghs-ability>
      </div>
      }
    </div>
  </div>
</div>